<template>
    <div class="CorBaseFundo" :style="CoresHionEffect">
      <div id="circuloExteno">
            <div id="circuloSemiExterno"></div>
            <div id="crossHorizontal"></div>
            <div id="crossVertical"></div>
            <div id="bola1"></div>
            <div id="bola2"></div>
            <div id="bola3"></div>
            <div id="bola4"></div>
            <div id="bola5"></div>
            <div id="bola6"></div>
            <div id="bola7"></div>
            <div id="bola8"></div>
            <div id="circuloInterno"></div>
            <div id="circuloSemiInterno"></div>
            <div id="crossInternaHorizontal"></div>
            <div id="crossInternaVertical"></div>
            <div id="bola11"></div>
            <div id="bola22"></div>
            <div id="bola33"></div>
            <div id="bola44"></div>
            <div id="bola55"></div>
            <div id="bola66"></div>
            <div id="bola77"></div>
            <div id="bola88"></div>
            <Lightning v-if="Raio" class="EffectRaioHion" :configLightning="configLightning" />
      </div>
    </div>
</template>

<script>
export default {
        name: 'HionEffect',
        data() {
                return {
                        backgroundHionEffect: "#000",
                        CorHionEffect: "#008fac",
                        configLightning: {
                                backgroundLightning: 'var(--HionEffect-background-color)',
                                CorLightning: 'var(--HionEffect-color)'
                        }
                };
	},
	components: { 
                Lightning: () => import(/* webpackChunkName: "lightninghome" */ "./lightning"),
        },
        props: ["configHionEffect", "Raio" ],
	computed: {
		CoresHionEffect: function () {
			return [
                                {"--HionEffect-background-color": this.backgroundHionEffect},
                                {"--HionEffect-color": this.CorHionEffect}
                        ];
		}
        },
        methods: {
                setConfiguracaoInicial() {
                        if(this.configHionEffect) {
                                if (this.configHionEffect.backgroundHionEffect) {
                                        this.backgroundHionEffect = this.configHionEffect.backgroundHionEffect;
                                }
                                if (this.configHionEffect.CorHionEffect) {
                                        this.CorHionEffect = this.configHionEffect.CorHionEffect
                                }
                                if (this.configHionEffect.CorRaio) {
                                        this.configLightning.CorLightning = this.configHionEffect.CorRaio
                                } else {
                                        this.configLightning.CorLightning = 'var(--HionEffect-color)'
                                }
                        }
                }
        },
        created() {
                this.setConfiguracaoInicial();
        }
};
</script>

<style>
.CorBaseFundo {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: var(--HionEffect-background-color);
}
#circuloExteno {
        position: relative;
        width: 100%;
        height: 100%;
        background: var(--HionEffect-color);
        border-radius: 50%;
}
#circuloSemiExterno {
        position: relative;
        width: 92%;
        height: 92%;
        background: var(--HionEffect-background-color);
        border-radius: 50%;
        top: 4%;
        left: 4%;
}
#crossHorizontal {
        background: var(--HionEffect-background-color);
        position: absolute;
        width: 100%;
        height: 20%;
        top: 40%;
        left: 0%;
        transform: rotate(45deg);
}
#crossVertical {
        background: var(--HionEffect-background-color);
        position: absolute;
        width: 20%;
        height: 100%;
        top: 0%;
        left: 40%;
        transform: rotate(45deg);
}
#bola1 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 7.65%;
        left: 22%;
        border-radius: 50%;
}
#bola2 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 22%;
        left: 7.65%;
        border-radius: 50%;
}
#bola3 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 74%;
        left: 7.65%;
        border-radius: 50%;
}
#bola4 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 88.35%;
        left: 22%;
        border-radius: 50%;
}
#bola5 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 88.35%;
        left: 74%;
        border-radius: 50%;
}
#bola6 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 74%;
        left: 88.35%;
        border-radius: 50%;
}
#bola7 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 22%;
        left: 88.4%;
        border-radius: 50%;
}
#bola8 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 7.65%;
        left: 74.05%;
        border-radius: 50%;
}
#circuloInterno {
        position: absolute;
        width: 70%;
        height: 70%;
        background: var(--HionEffect-color);
        border-radius: 50%;
        top: 15%;
        left: 15%;
}
#circuloSemiInterno {
        position: absolute;
        width: 62%;
        height: 62%;
        background: var(--HionEffect-background-color);
        border-radius: 50%;
        top: 19%;
        left: 19%;
}
#crossInternaHorizontal {
        background: var(--HionEffect-background-color);
        position: absolute;
        width: 100%;
        height: 14%;
        top: 43.1%;
        left: 0%;
        transform: rotate(45deg);
}
#crossInternaVertical {
        background: var(--HionEffect-background-color);
        position: absolute;
        width: 14%;
        height: 100%;
        top: 0%;
        left: 43.1%;
        transform: rotate(45deg);
}
#bola11 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 20.15%;
        left: 30.3%;
        border-radius: 50%;
}
#bola22 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 30.25%;
        left: 20.1%;
        border-radius: 50%;
}
#bola33 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 65.7%;
        left: 20.1%;
        border-radius: 50%;
}
#bola44 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 75.85%;
        left: 30.25%;
        border-radius: 50%;
}
#bola55 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 75.7%;
        left: 65.8%;
        border-radius: 50%;
}
#bola66 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 65.8%;
        left: 75.8%;
        border-radius: 50%;
}
#bola77 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 30.25%;
        left: 75.8%;
        border-radius: 50%;
}
#bola88 {
        background: var(--HionEffect-color);
        position: absolute;
        width: 4%;
        height: 4%;
        top: 20.15%;
        left: 65.8%;
        border-radius: 50%;
}
.EffectRaioHion {
        position: absolute;
        width: 45%;
        height: 50%;
        top: 25%;
        left: 27.5%;
}
</style>